import { CALL_API } from 'store/middleware/api';
import { getFormData } from 'utils/type/isFormData';


export const LOAD_GROUP_CONTEXT_CONTACT = ('LOAD_GROUP_CONTEXT_CONTACT');
export const SEARCH_GROUP_CONTEXT_CACHED_CONTACT = ('SEARCH_GROUP_CONTEXT_CACHED_CONTACT');
export const UPDATE_GROUP_CONTEXT_CONTACT = ('UPDATE_GROUP_CONTEXT_CONTACT');
export const SELECT_GROUP_CONTEXT_CONTACT = ('SELECT_GROUP_CONTEXT_CONTACT');
export const ASSIGN_CONTACTS = ('ASSIGN_CONTACTS');
export const UNASSIGN_CONTACTS = ('UNASSIGN_CONTACTS');
export const ASSIGN_CONTACTS_CHUNK = ('ASSIGN_CONTACTS_CHUNK');
export const ASSIGN_CONTACTS_DONE = ('ASSIGN_CONTACTS_DONE');

export const LOAD_CONTACT = ('LOAD_CONTACT');
export const LOAD_CONTACT_ERROR = ('LOAD_CONTACT_ERROR');
export const LOAD_CONTACT_SUCCESS = ('LOAD_CONTACT_SUCCESS');
export const SAVE_CONTACT = ('SAVE_CONTACT');
export const SAVE_CONTACT_SUCCESS = ('SAVE_CONTACT_SUCCESS');
export const SAVE_CONTACT_ERROR = ('SAVE_CONTACT_ERROR');
export const DELETE_CONTACT_GROUP = ('DELETE_CONTACT_GROUP');
export const DELETE_CONTACT_GROUP_SUCCESS = ('DELETE_CONTACT_GROUP_SUCCESS');
export const DELETE_CONTACT_GROUP_ERROR = ('DELETE_CONTACT_GROUP_ERROR');
export const IMPORT_CONTACTS = ('IMPORT_CONTACTS');
export const IMPORT_CONTACTS_SUCCESS = ('IMPORT_CONTACTS_SUCCESS');
export const IMPORT_CONTACTS_ERROR = ('IMPORT_CONTACTS_ERROR');
export const EXPORT_CONTACTS = ('EXPORT_CONTACTS');
export const EXPORT_CONTACTS_SUCCESS = ('EXPORT_CONTACTS_SUCCESS');
export const EXPORT_CONTACTS_ERROR = ('EXPORT_CONTACTS_ERROR');
export const APPEND_CONTACTS = ('APPEND_CONTACTS');
export const APPEND_CONTACTS_SUCCESS = ('APPEND_CONTACTS_SUCCESS');
export const APPEND_CONTACTS_ERROR = ('APPEND_CONTACTS_ERROR');
export const GET_APPEND_JOB = ('GET_APPEND_JOB');
export const GET_APPEND_JOB_SUCCESS = ('GET_APPEND_JOB_SUCCESS');
export const GET_APPEND_JOB_ERROR = ('GET_APPEND_JOB_ERROR');
export const UPDATE_APPEND_JOB = ('UPDATE_APPEND_JOB');
export const UPDATE_APPEND_JOB_SUCCESS = ('UPDATE_APPEND_JOB_SUCCESS');
export const UPDATE_APPEND_JOB_ERROR = ('UPDATE_APPEND_JOB_ERROR');
export const UPDATE_CONTACT_GROUP = ('UPDATE_CONTACT_GROUP');
export const UPDATE_CONTACT_GROUP_SUCCESS = ('UPDATE_CONTACT_GROUP_SUCCESS');
export const UPDATE_CONTACT_GROUP_ERROR = ('UPDATE_CONTACT_GROUP_ERROR');
export const SEARCH_GROUP_CONTEXT_CONTACT = ('SEARCH_GROUP_CONTEXT_CONTACT');
export const SEARCH_GROUP_CONTEXT_CONTACT_SUCCESS = ('SEARCH_GROUP_CONTEXT_CONTACT_SUCCESS');
export const SEARCH_GROUP_CONTEXT_CONTACT_ERROR = ('SEARCH_GROUP_CONTEXT_CONTACT_ERROR');
export const DELETE_GROUP_CONTEXT_CONTACT = ('DELETE_GROUP_CONTEXT_CONTACT');
export const DELETE_GROUP_CONTEXT_CONTACT_SUCCESS = ('DELETE_GROUP_CONTEXT_CONTACT_SUCCESS');
export const DELETE_GROUP_CONTEXT_CONTACT_ERROR = ('DELETE_GROUP_CONTEXT_CONTACT_ERROR');
export const SAVE_GROUP_CONTEXT_CONTACT = ('SAVE_GROUP_CONTEXT_CONTACT');
export const SAVE_GROUP_CONTEXT_CONTACT_SUCCESS = ('SAVE_GROUP_CONTEXT_CONTACT_SUCCESS');
export const SAVE_GROUP_CONTEXT_CONTACT_ERROR = ('SAVE_GROUP_CONTEXT_CONTACT_ERROR');
export const SAVE_DNC_STATUS_FOR_ACCOUNT_PHONENUMBERS = ('SAVE_DNC_STATUS_FOR_ACCOUNT_PHONENUMBERS');
export const SAVE_DNC_STATUS_FOR_ACCOUNT_PHONENUMBERS_SUCCESS = ('SAVE_DNC_STATUS_FOR_ACCOUNT_PHONENUMBERS_SUCCESS');
export const SAVE_DNC_STATUS_FOR_ACCOUNT_PHONENUMBERS_ERROR = ('SAVE_DNC_STATUS_FOR_ACCOUNT_PHONENUMBERS_ERROR');
export const GET_CONTACT_IDS = ('GET_CONTACT_IDS');
export const GET_CONTACT_IDS_SUCCESS = ('GET_CONTACT_IDS_SUCCESS');
export const GET_CONTACT_IDS_ERROR = ('GET_CONTACT_IDS_ERROR');
export const GET_SAMPLE = ('GET_SAMPLE');
export const GET_SAMPLE_SUCCESS = ('GET_SAMPLE_SUCCESS');
export const GET_SAMPLE_ERROR = ('GET_SAMPLE_ERROR');
export const CHECK_SKIP_TRACED = ('CHECK_SKIP_TRACED');
export const CHECK_SKIP_TRACED_SUCCESS = ('CHECK_SKIP_TRACED_SUCCESS');
export const CHECK_SKIP_TRACED_ERROR = ('CHECK_SKIP_TRACED_ERROR');
export const CHECK_SKIP_TRACED_GROUP = ('CHECK_SKIP_TRACED_GROUP');
export const CHECK_SKIP_TRACED_GROUP_SUCCESS = ('CHECK_SKIP_TRACED_GROUP_SUCCESS');
export const CHECK_SKIP_TRACED_GROUP_ERROR = ('CHECK_SKIP_TRACED_GROUP_ERROR');

const request = data => ({ [CALL_API]: data });

function mapToObj(map){
  const obj = {}
  for (let [k,v] of map)
    obj[k] = v
  return obj
}

function contacts(method, path, startType, successType, errorType, body, { afterSuccess, afterError, successParams, query, download } = {}) {
  return request({
    method,
    startType,
    successType,
    errorType,
    body: body ? JSON.stringify(mapToObj(body)) : null,
    path: `/resource/auth/ps4/user/contacts/${path}`,
    afterSuccess,
    afterError,
    successParams,
    query,
    download,
    headers: { 'Content-Type': 'application/json' }
  });
}

function contactsImports(method, path, startType, successType, errorType, body, { afterSuccess, afterError, successParams, query, download } = {}) {
  return request({
    method,
    startType,
    successType,
    errorType,
    body,
    path: `/resource/auth/ps4/user/contacts/${path}`,
    afterSuccess,
    afterError,
    successParams,
    query,
    download
  });
}

function contactSave(method, path, startType, successType, errorType, body, { afterSuccess, afterError, successParams, query, download, skipGlobalErrorHandler } = {} ) {
  return request({
    method,
    startType,
    successType,
    errorType,
    body: body,
    path: `/resource/auth/ps4/user/contacts/${path}`,
    afterSuccess,
    skipGlobalErrorHandler,
    afterError: (response) => {
      // Call the afterError callback if provided
      if (afterError) {
        afterError(response);
      }
      return response;
    },
    successParams,
    query,
    download,
    headers: { 'Content-Type': 'application/json' }
  });
}

function contactsSuccess(method, path, startType, successType, errorType, body, { afterSuccess, afterError, successParams, query, download } = {}) {
  return request({
    method,
    startType,
    successType,
    errorType,
    body: body ? JSON.stringify(mapToObj(body)) : null,
    path: `/resource/auth/ps4/user/contacts/${path}`,
    afterSuccess: (response) => {
      // Call the afterSuccess callback if provided
      if (afterSuccess) {
        afterSuccess({ response });
      }
      // Return the response
      return response;
    },
    afterError,
    successParams,
    query,
    download,
    headers: { 'Content-Type': 'application/json' }
  });
}

export const getSearch = context => context.merge({ data: null, info: null, fullSelection: null, name: context.getIn(['info', 'name']), type: context.getIn(['info', 'type']) });

export const loadContact = (id, afterSuccess) => contactsSuccess('get', `new/${id}`, LOAD_CONTACT, LOAD_CONTACT_SUCCESS, LOAD_CONTACT_ERROR, null, { afterSuccess });

export const saveContact = (contact, afterSuccess) => contactSave('put', 'new', SAVE_CONTACT, SAVE_CONTACT_SUCCESS, SAVE_CONTACT_ERROR, contact, { afterSuccess });

export const importContacts = (file, groupName, afterSuccess) => contactsImports('post', 'new', IMPORT_CONTACTS, IMPORT_CONTACTS_SUCCESS, IMPORT_CONTACTS_ERROR, getFormData([{ name: 'file', file }, { name: 'groupName', value: groupName || '' }]), { afterSuccess });

// export const appendContacts = (data, paymentMethodId, cardCode, paymentAmount, creditAmount, afterSuccess) => contactSave('post', 'appendjobs', APPEND_CONTACTS, APPEND_CONTACTS_SUCCESS, APPEND_CONTACTS_ERROR, data, { afterSuccess, query: { paymentMethodId, cardCode, paymentAmount, creditAmount } });
export const appendContacts = (
  data,
  paymentMethodId,
  cardCode,
  paymentAmount,
  creditAmount,
  callback
) =>
  contactSave(
    "post",
    "appendjobs",
    APPEND_CONTACTS,
    APPEND_CONTACTS_SUCCESS,
    APPEND_CONTACTS_ERROR,
    data,
    {
      query: { paymentMethodId, cardCode, paymentAmount, creditAmount },
      skipGlobalErrorHandler: true,

      afterSuccess: (body) => {
        const statusCode =
          body?.rawResponse?.status ||
          body?.statusCode ||
          200;

        callback({
          response: body,
          statusCode,
          error: null,
        });
      },

      afterError: (body) => {
        const statusCode =
          body?.response?.statusCode ||
          body?.rawResponse?.status ||
          500;

        callback({
          response: null,
          statusCode,
          error: body,
        });
      },
    }
  );

export const getAppendJobEstimate = (data, afterSuccess) => contactSave('post', 'appendjobs/estimate', GET_APPEND_JOB, GET_APPEND_JOB_SUCCESS, GET_APPEND_JOB_ERROR, data, { afterSuccess, skipGlobalErrorHandler: true });

export const getAppendJob = (id, afterSuccess) => contacts('get', `appendjobs/${id}`, GET_APPEND_JOB, GET_APPEND_JOB_SUCCESS, GET_APPEND_JOB_ERROR, null, { afterSuccess, skipGlobalErrorHandler: true });

export const updateAppendJob = (job, afterSuccess) => contactSave('put', 'appendjobs', UPDATE_APPEND_JOB, UPDATE_APPEND_JOB_SUCCESS, UPDATE_APPEND_JOB_ERROR, job, { afterSuccess, skipGlobalErrorHandler: true });

export const updateContactGroup = group => contactSave('put', 'new/groups/update', UPDATE_CONTACT_GROUP, UPDATE_CONTACT_GROUP_SUCCESS, UPDATE_CONTACT_GROUP_ERROR, group);

export const getSampleContact = ids => contactSave('post', 'sample', GET_SAMPLE, GET_SAMPLE_SUCCESS, GET_SAMPLE_ERROR, ids);

export const checkSkipTraced = (data, afterSuccess) => contactSave('post', 'check-skip-traced', CHECK_SKIP_TRACED, CHECK_SKIP_TRACED_SUCCESS, CHECK_SKIP_TRACED_ERROR, data, { afterSuccess, skipGlobalErrorHandler: true });

export const checkSkipTracedGroup = (contactGroupId, afterSuccess) => contacts('get', `check-skip-traced-group/${contactGroupId}`, CHECK_SKIP_TRACED_GROUP, CHECK_SKIP_TRACED_GROUP_SUCCESS, CHECK_SKIP_TRACED_GROUP_ERROR, null, { afterSuccess, skipGlobalErrorHandler: true });

export const loadGroupContext = (name, groupId, defaults) => ({ type: LOAD_GROUP_CONTEXT_CONTACT, name, groupId, defaults });

export const searchGroupContext = (context) => {
  if (context.getIn(['info', 'data']) && context.getIn(['info', 'index'])) return { type: SEARCH_GROUP_CONTEXT_CACHED_CONTACT, context };
  return contacts('post', 'new/groups', SEARCH_GROUP_CONTEXT_CONTACT, SEARCH_GROUP_CONTEXT_CONTACT_SUCCESS, SEARCH_GROUP_CONTEXT_CONTACT_ERROR, getSearch(context).set('selection', null), { successParams: { context } });
};

export const loadContextIds = (context, selection) => contactSave('post', 'new/groups', SEARCH_GROUP_CONTEXT_CONTACT, SEARCH_GROUP_CONTEXT_CONTACT_SUCCESS, SEARCH_GROUP_CONTEXT_CONTACT_ERROR, { selection }, { successParams: { context } });

export const updateGroupContext = context => ({ type: UPDATE_GROUP_CONTEXT_CONTACT, context });

export const updateGroupContextSelection = (context, select, index) => ({ type: SELECT_GROUP_CONTEXT_CONTACT, context, select, index });

export const deleteGroupContext = (context,afterSuccess) => contacts('delete', 'new', DELETE_GROUP_CONTEXT_CONTACT, DELETE_GROUP_CONTEXT_CONTACT_SUCCESS, DELETE_GROUP_CONTEXT_CONTACT_ERROR, getSearch(context), {afterSuccess});

export const getContactIds = (id, afterSuccess, afterError) => contacts('get', `new/groups/${id}/ids`, GET_CONTACT_IDS, GET_CONTACT_IDS_SUCCESS, GET_CONTACT_IDS_ERROR, null, { afterSuccess, afterError });

export const searchContactIds = (context) => contacts('post', 'new/groups/ids', GET_CONTACT_IDS, GET_CONTACT_IDS_SUCCESS, GET_CONTACT_IDS_ERROR, getSearch(context), { afterSuccess });

export const saveGroupContext = (context, afterSuccess) => contacts('put', 'new/groups', SAVE_GROUP_CONTEXT_CONTACT, SAVE_GROUP_CONTEXT_CONTACT_SUCCESS, SAVE_GROUP_CONTEXT_CONTACT_ERROR, getSearch(context), { afterSuccess });

export const exportContacts = context => contacts('post', 'new/export', EXPORT_CONTACTS, EXPORT_CONTACTS_SUCCESS, EXPORT_CONTACTS_ERROR, getSearch(context), { download: true });

export const deleteContactGroup = (groupId,afterSuccess) => contacts('delete', `new/groups/${groupId?.substr(1)}`, DELETE_CONTACT_GROUP, DELETE_CONTACT_GROUP_SUCCESS, DELETE_CONTACT_GROUP_ERROR,null,{afterSuccess});

export const saveDNCStatusForAccountPhoneNumbers = (phoneNumberDNCListRequest) => contactSave('post', 'phone-numbers/dnc', SAVE_DNC_STATUS_FOR_ACCOUNT_PHONENUMBERS, SAVE_DNC_STATUS_FOR_ACCOUNT_PHONENUMBERS_SUCCESS, SAVE_DNC_STATUS_FOR_ACCOUNT_PHONENUMBERS_ERROR, phoneNumberDNCListRequest);

export const assignContext = () => ({ type: ASSIGN_CONTACTS });

export const unassignContext = () => ({ type: UNASSIGN_CONTACTS });

// Thunk: assign selected contacts in small chunks to avoid blocking the main thread.
export const assignContextAsync = (options = {}, excludeIds = null) => (dispatch, getState) => {
  const state = getState();
  const availableCtx = state.getIn(['contacts', 'contexts', 'available', 'group']);
  if (!availableCtx) return Promise.resolve();

  const data = availableCtx.get('data') || [];
  // Expected: data is ImmutableJS List/Map
  let allIds = [];
  try {
    const selectedData = data.filter(d => d.get && d.get('selected'));
    allIds = selectedData.toJS ? selectedData.map(d => d.get('id')).toJS() : [];
    allIds = !excludeIds ? allIds : allIds.filter((item) => !excludeIds.includes(item));
  } catch (e) {
    console.warn('Failed to extract selected contact IDs:', e);
    allIds = [];
  }

  if (!allIds.length) return Promise.resolve();

  const chunkSize = options.chunkSize || 200;
  const delay = typeof options.delay === 'number' ? options.delay : 30;

  let i = 0;
  return new Promise((resolve) => {
    const step = () => {
      const chunk = allIds.slice(i, i + chunkSize);
      if (chunk.length) dispatch({ type: ASSIGN_CONTACTS_CHUNK, payload: { chunkIds: chunk } });
      i += chunkSize;
      if (i < allIds.length) setTimeout(step, delay);
      else {
        dispatch({ type: ASSIGN_CONTACTS_DONE });
        resolve();
      }
    };
    step();
  });
};
